import { Controller } from 'stimulus'
import copyTextInput from '../../../library/click-link'
import toastr from 'toastr'

export default class extends Controller {
  static targets = ['source', 'backLinkLeadSource', 'inputLeadSource']

  connect() {
    this.setCopyLink()
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  }

  copyLink () {
    copyTextInput(this.inputLeadSourceTarget, this.callback)
  }

  checkUrl() {
    if (!this.backLinkLeadSourceTarget.value.includes("https://") && !this.backLinkLeadSourceTarget.value.includes("http://")) {
      this.backLinkLeadSourceTarget.nextElementSibling.innerHTML = 'INVALID URL. Please include http:// or https:// address.'
    } else if (!this.backLinkLeadSourceTarget.checkValidity()) {
      this.backLinkLeadSourceTarget.nextElementSibling.innerHTML = inpObj.validationMessage
    } else {
      this.backLinkLeadSourceTarget.nextElementSibling.innerHTML = ''
    }

    this.setCopyLink();
  }

  setCopyLink () {
    let url = this.sourceTarget.dataset.baseUrl;
    let value = this.sourceTarget.value;

    url = url + '?customer_get_in_touch=' + value;

    if(this.backLinkLeadSourceTarget.value && this.backLinkLeadSourceTarget.checkValidity()) {
      url = url + '&back_url=' + this.backLinkLeadSourceTarget.value
    }

    this.inputLeadSourceTarget.value = url
  }

  callback () {
    toastr.success("URL Copied")
  }
}
